// app/renderer/ui/rehearsal/section-colors.js
//
// Pure helpers: semantic name → color match + cycle palette fallback.
// No DOM, no I/O. Tested without JSDOM.

export const PALETTE = Object.freeze([
  '#1d4e7a', // navy
  '#1e6e6e', // teal
  '#a87a1f', // gold
  '#5e3a8a', // purple
  '#b85c2c', // orange
  '#3a7a3a', // green
  '#8a3a6e', // magenta
  '#5a5a5a', // grey
]);

// Substring matching: any rule whose key appears anywhere in the normalized
// name wins. First rule that matches takes priority — so when adding new
// rules, place more-specific keys before less-specific ones (pre-chorus
// before chorus, припев-проигрыш before припев). This means "Tagline" will
// match `tag` and "Subverses" will match `verse` — accept this for
// canonical-name use cases (Verse 1 / Chorus / Куплет / Pre-chorus).
const SEMANTIC_RULES = [
  { keys: ['pre-chorus', 'prechorus', 'припев-проигрыш', 'предприпев'], color: '#5e3a8a' },
  { keys: ['intro', 'вступление', 'интро'],                              color: '#1d4e7a' },
  { keys: ['verse', 'куплет'],                                           color: '#1e6e6e' },
  { keys: ['chorus', 'припев'],                                          color: '#a87a1f' },
  { keys: ['bridge', 'бридж', 'мост'],                                   color: '#b85c2c' },
  { keys: ['solo', 'instrumental', 'проигрыш', 'соло'],                  color: '#3a7a3a' },
  { keys: ['outro', 'ending', 'аутро', 'концовка', 'финал'],             color: '#5a5a5a' },
  { keys: ['tag', 'refrain', 'реприз', 'рефрен'],                        color: '#8a3a6e' },
];

export function matchSemantic(name) {
  if (typeof name !== 'string') return null;
  const norm = name.trim().toLowerCase();
  if (!norm) return null;
  for (const rule of SEMANTIC_RULES) {
    if (rule.keys.some(k => norm.includes(k))) return rule.color;
  }
  return null;
}

export function nextCycleColor(usedCount) {
  const i = Math.max(0, Number.isFinite(usedCount) ? usedCount : 0);
  return PALETTE[i % PALETTE.length];
}
